export default "__VITE_ASSET__Dc4EEs4g__"